import './About.css';
import { HiBadgeCheck } from 'react-icons/hi';
import { VscCalendar } from 'react-icons/vsc';
import './Home.css';
import { GiSkills } from 'react-icons/gi';

const WorkHistory = () => {
    return (
                <section className="about" id="expirience">
            <h2 className="title">Experience</h2>
            <hr className="hr" />

            <div className="expdiv">
                <div className='iconText'>
                    <HiBadgeCheck className="check" />
                    <span>
                        Blockchain Software Engineer{' '}
                        <a href="http://paycrest.io/">@paycrest.io</a>, Remote, USA
                    </span>
                </div>
                <div className='iconText'>
                    <VscCalendar className="check" />
                    <span>May 2024 – Present</span>
                </div>
                <div className="Item">
                    <li>Pioneered on-ramp implementation through EIP-7702</li>
                    <li>Designed and implemented Paycrest's decentralized re-routing liquidity payment gateway.</li>
                    <li>Designed and architecture the Gateway escrow smart contract</li>
                    <li>Developed Golang-based microservices that aggregate and route payments through provision nodes connected to PSPs.</li>
                    <li>Led implementation of automated liquidity aggregation and account abstraction logic.</li>
                    <li>Integrated Near-Intent and Relay for cross-chain intent-based transactions.</li>
                    <li>Contributed to building backend services in Golang and smart contracts in Solidity, focusing on performance and modularity using Priority Queue.</li>
                    <li>Developed backend services in Golang with PostgreSQL, Redis, Docker, and Kubernetes, ensuring modularity, low-latency, and high availability.</li>
                    <li>Optimized transaction processing with priority queues and RPC-level enhancements, reducing refund rates by 75%.</li>
                    <li>Collaborated across teams to deliver clean, production-ready code spanning both backend infrastructure and Solidity smart contracts.</li>
                    <strong className='strongText'>Technologies: Go, Solidity, NodeJS, TypeScript, Docker, PostgreSQL, Redis, LibP2P, CI/CD, RPC calls, REST APIs, Ethereum, Account Abstraction.</strong>
                </div>
            </div>

            <div className="expdiv">
                <div className='iconText'>
                    <HiBadgeCheck className="check" />
                    <span>
                        Smart Contract Engineer{' '}
                        <a href="https://pos-ley.com/">@Posley</a>, Remote, Hong-Kong
                    </span>
                </div >
                <div className='iconText'>
                    <VscCalendar className="check" />
                    <span>Jan 2023 – Nov 2024</span>
                </div>
                <div className="Item">
                    <li>Owning the full lifecycle from design to deployment of a leverage vault (Vaultka) system supporting perpetual DEX operations with advanced risk and liquidation logic.</li>
                    <li>Spearheaded the development team for Airpuff, coordinating cross-functional efforts to build a protocol for leveraging LRTS assets and integrating with EigenLayer and restaking primitives.</li>
                    <li>Led the internal auditing of all products released by Posley</li>
                    <li>Directed engineering initiatives to develop secure vault strategies with dynamic liquidation, profit-sharing, and asset management capabilities.</li>
                    <li>Led technical architecture decisions and managed integrations with protocols including GMX, HMX, VELA, KTX Finance, EigenLayer, Ether.fi, Pendle (PTs), Renzo, Bedrock, Vector, Kyber, Compound, Morpho, and Gains Network.</li>
                    <li>Successfully managed and scaled operations supporting over $120M in TVL across the Posley ecosystem under my technical leadership.</li>
                    <li>Established engineering best practices and led the team in building modular, testable smart contracts while orchestrating off-chain logic for strategy execution.</li>
                    <li>Coordinated multi-chain deployment efforts across Arbitrum, Optimism, zkEVM, and other L2s, ensuring battle-tested infrastructure delivery.</li>
                    <li>Led collaborative efforts with strategy researchers, product, and frontend teams to ship quickly and securely while maintaining high code quality standards.</li>
                    <strong className='strongText'>Technologies: Solidity, Hardhat, OpenZeppelin, Foundry, TypeScript, NodeJS</strong>
                    <br />
                    <strong className='strongText'>
                        <a href='https://hmx.org/arbitrum/'>HMX</a><span> (Provides 1,000x leverage), </span>
                        <a href='https://www.vela.exchange/'>VELA</a>,{" "}
                        <a href='https://www.ktx.finance/'>KTX Finance</a>,{" "}
                        <a href='https://www.eigenlayer.xyz/'>EigenLayer</a>,{" "}
                        <a href='https://app.pendle.finance/trade/markets'>pendle principal tokens</a>,{" "}
                        <a href='https://www.renzoprotocol.com/'>Renzo</a>,{" "}
                        <a href='https://www.bedrock.technology/'>Bedrock</a>,{" "}
                        <a href='https://www.vectorreserve.com/dapp/vec'>Vector</a>, etc.
                    </strong>
                    <br />
                    <strong>
                        Link to projects: <a href='https://www.vaultka.com/'>Vaultka</a>,{" "}
                        <a href='https://www.airpuff.io/'>Airpuff</a> <span>and</span>{" "}
                        <a href='https://solana.vaultka.com/'>Vaultka Solana</a>
                    </strong>
                </div>
            </div>

            <div className="expdiv">
                <div className='iconText'>
                    <HiBadgeCheck className="check" />
                    <span>
                        Smart Contract Engineer{' '}
                        <a href="https://www.nethermind.io/">@Nethermind.io</a>, London, UK
                    </span>
                </div>
                <div className='iconText'>
                    <VscCalendar className="check" />
                    <span>August 2022 – Dec 2022</span>
                </div>
                <div className="Item">
                    <li>Conducted smart contract audits, reviewing over 35,000 lines of code across multiple projects.</li>
                    <li>Identified and resolved a wide range of security vulnerabilities, ensuring the robustness and integrity of Web3 applications.</li>
                    <li>Highlighted and found over 91 security vulnerabilities across audited products.</li>
                    <li>Collaborated with top-tier development teams to deliver secure, high-quality blockchain solutions.</li>
                    <li>Selected as a speaker at a Nethermind event.</li>
                </div>
            </div>

            <div className="expdiv">
                <div className='iconText'>
                    <HiBadgeCheck className="check" />
                    <span>
                        Lead Smart Contract Engineer{' '}
                        <a href="https://www.rigelprotocol.com/">
                            @RigelProtocol Lab
                        </a>, Remote, UK
                    </span>
                </div>
                <div className='iconText'>
                    <VscCalendar className="check" />
                    <span>Feb 2020 – Sept 2022</span>
                </div>
                <div className="Item">
                    <li>Led a team of 8+ engineers to build Rigel Protocol products</li>
                    <li>Designed, developed, and deployed Rigel protocol Decentralized P2P systems from smart contract to backend Architecture.</li>
                    <li>Managed and coordinated the development of a Decentralized Peer to Peer system, overseeing the design and implementation of smart contracts enabling secure, non-custodial asset transfers and escrow logic.</li>
                    <li>Led the design and architecture of Rigel Protocol's launchpad and NFT marketplace, creating secure and scalable smart contracts for token launches and NFT transactions.</li>
                    <li>Spearheaded the development of the Gifting dApp, managing team resources to build support for one-time and scheduled asset distribution via deterministic addresses and off-chain metadata encryption.</li>
                    <li>Led the development of a DAO smart contract.</li>
                    <li>Led cross-functional collaboration with frontend and backend teams to ensure seamless contract integration with React-based dApps and GraphQL APIs.</li>
                    <li>Established mentorship programs and led training initiatives for junior engineers in Solidity, testing workflows (Foundry/Hardhat), and best practices in secure smart contract development.</li>
                    <li>Successfully scaled the platform to over 1000 users within six months under my technical leadership.</li>
                    <strong className='strongText'>Technologies: Solidity, Hardhat, OpenZeppelin, Foundry, TypeScript, Slither, Echidna</strong>
                </div>
            </div>

            <div className="expdiv">
                <h3 className="title">NOTABLE ACHIEVEMENTS (AUDIT CONTEST, BUG BOUNTY)</h3>
                <div className="achievements-table">
                    <table className="expertise-table">
                        <thead>
                            <tr>
                                <th className="category-header">Title</th>
                                <th className="details-header">Platform</th>
                                <th className="note-header">Note</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="category"><strong>Concrete Finance</strong></td>
                                <td className="details">Code4rena</td>
                                <td className="note">Found 11 Issues</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>Peapod Finance</strong></td>
                                <td className="details">Sherlock</td>
                                <td className="note">Found 2 Medium</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>Alchemix Transmuter</strong></td>
                                <td className="details">CodeHawk</td>
                                <td className="note">Rank #3</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>Debita Finance</strong></td>
                                <td className="details">Sherlock</td>
                                <td className="note">Found 3 Medium</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>Plaza Finance</strong></td>
                                <td className="details">Sherlock</td>
                                <td className="note">Found 1 High</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>Second Swap</strong></td>
                                <td className="details">Code4rena</td>
                                <td className="note">Found 1 High</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>QuantAMM</strong></td>
                                <td className="details">CodeHawk</td>
                                <td className="note">Found 1 Medium</td>
                            </tr>
                            <tr>
                                <td className="category"><strong>Lambo.win</strong></td>
                                <td className="details">Code4rena</td>
                                <td className="note">Found 1 High</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="expdiv">
                <h3 className="title">Link to active DApps and Profiles:</h3>
                <div className="Item">
                    <li><strong>Vaultka by Posley:</strong> <a href="https://www.vaultka.com/" target="_blank" rel="noopener noreferrer">https://www.vaultka.com/</a></li>
                    <li><strong>Airpuff by Posley:</strong> <a href="https://www.airpuff.io/" target="_blank" rel="noopener noreferrer">https://www.airpuff.io/</a></li>
                    <li><strong>Decentralized P2P system by Rigel Protocol Lab:</strong> <a href="https://p2p.rigelprotocol.com/" target="_blank" rel="noopener noreferrer">https://p2p.rigelprotocol.com/</a></li>
                    <li><strong>Vaultka on Solana by Posley:</strong> <a href="https://solana.vaultka.com/" target="_blank" rel="noopener noreferrer">https://solana.vaultka.com/</a></li>
                    <li><strong>Launchpad by Rigel Protocol Lab:</strong> <a href="https://launchpad.rigelprotocol.com/" target="_blank" rel="noopener noreferrer">https://launchpad.rigelprotocol.com/</a></li>
                    <li><strong>Smart Swap (DEFI) by Rigel Protocol Lab:</strong> <a href="https://smartswap.rigelprotocol.com/" target="_blank" rel="noopener noreferrer">https://smartswap.rigelprotocol.com/</a></li>
                    <li><strong>Bidding System by Rigel Protocol Lab:</strong> <a href="https://www.rigelprotocol.com/" target="_blank" rel="noopener noreferrer">https://www.rigelprotocol.com/</a></li>
                    <li><strong>NoBlock by Paycrest:</strong> <a href="https://www.noblocks.xyz/" target="_blank" rel="noopener noreferrer">https://www.noblocks.xyz/</a></li>
                    <li><strong>Cantina Profile:</strong> <a href="https://cantina.xyz/u/Prosper" target="_blank" rel="noopener noreferrer">https://cantina.xyz/profile/prosper</a></li>
                    <li><strong>Sherlock Profile:</strong> <a href="https://audits.sherlock.xyz/watson/prosper" target="_blank" rel="noopener noreferrer">https://audits.sherlock.xyz/watson/prosper</a></li>
                    <li><strong>Code4Arena Profile:</strong> <a href="https://code4rena.com/@Prosperity" target="_blank" rel="noopener noreferrer">https://code4rena.com/@Prosperity</a></li>
                    <li><strong>CodeHawks Profile:</strong> <a href="https://profiles.cyfrin.io/u/otor" target="_blank" rel="noopener noreferrer">https://profiles.cyfrin.io/u/otor</a></li>
                </div>
            </div>

        </section>
    );
}

export default WorkHistory;
